import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { useEvaluateInAppQuery } from '../../../__generated__/chirp/com/hubspot/purchase/motions/rpc/PurchaseMotionsEvaluationService.hooks';
import DisabledDowngradeButton from '../components/purchase-motions/DisabledDowngradeButton';
import RedirectToCustomerPlatformButton from '../components/purchase-motions/RedirectToCustomerPlatformButton';
import RedirectToMarketingPlusButton from '../components/purchase-motions/RedirectToMarketingPlusButton';
import { SingleSkeletonLoader } from '../components/SingleSkeletonLoader';
import { usePurchaseMotionOverrides } from '../hooks/purchase-motions/usePurchaseMotionOverrides';
import { PurchaseMotionCTAWrapper } from './PurchaseMotionCTAWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const PurchaseMotionsByProductApiNameAndLocation = ({
  displayCount,
  location,
  productApiName,
  purchaseRequest,
  skipInterstitial,
  trackingData,
  size = 'default'
}) => {
  var _purchaseMotionsQuery;
  const {
    loading: overrideLoading,
    type: overrideType
  } = usePurchaseMotionOverrides(productApiName);
  const purchaseMotionsQuery = useEvaluateInAppQuery({
    variables: {
      productApiNames: [productApiName],
      locations: [location]
    },
    skip: overrideLoading || !productApiName || !location
  });
  if (overrideLoading || purchaseMotionsQuery.loading) {
    if (displayCount) {
      return /*#__PURE__*/_jsx(_Fragment, {
        children: Array.from({
          length: displayCount
        }, (__, index) => /*#__PURE__*/_jsx(SingleSkeletonLoader, {
          height: 40
        }, `purchase-motion-loader-${index}-${productApiName}-${location}`))
      });
    }
    return /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 40
    });
  }
  if (overrideType === 'DISABLED_DOWNGRADE') {
    return /*#__PURE__*/_jsx(DisabledDowngradeButton, {
      size: size
    });
  }
  if (overrideType === 'REDIRECT_MARKETING_PLUS') {
    return /*#__PURE__*/_jsx(RedirectToMarketingPlusButton, {
      trackingSource: trackingData.source,
      size: size
    });
  }
  if (overrideType === 'REDIRECT_CUSTOMER_PLATFORM') {
    return /*#__PURE__*/_jsx(RedirectToCustomerPlatformButton, {
      trackingSource: trackingData.source,
      size: size
    });
  }
  const purchaseMotions = purchaseMotionsQuery.error ? ['TALK_TO_SALES_FALLBACK'] : (_purchaseMotionsQuery = purchaseMotionsQuery.data) === null || _purchaseMotionsQuery === void 0 || (_purchaseMotionsQuery = _purchaseMotionsQuery.purchaseMotionsMapping.productsByLocationString[location]) === null || _purchaseMotionsQuery === void 0 ? void 0 : _purchaseMotionsQuery.purchaseMotionsByProductApiName[productApiName].purchaseMotions;
  if (!purchaseMotions || purchaseMotions.length === 0) {
    return /*#__PURE__*/_jsx(View, {
      blockSize: "40px",
      inlineSize: "100%"
    });
  }
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    justifyContent: "center",
    gap: "200",
    inlineSize: "100%",
    children: Array.from({
      length: displayCount || purchaseMotions.length
    }, (__, displayIndex) => {
      const purchaseMotion = purchaseMotions[displayIndex];
      return /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(PurchaseMotionCTAWrapper, {
          purchaseMotion: purchaseMotion,
          trackingData: trackingData,
          productApiName: productApiName,
          location: location,
          displayIndex: displayIndex,
          purchaseRequest: purchaseRequest,
          skipInterstitial: skipInterstitial
        })
      }, `purchase-motion-${purchaseMotion.toString()}`);
    })
  });
};